module.exports = __webpack_public_path__ + "static/media/UploadButton_Dark.253db778.svg";